import React from 'react';
import { motion } from 'framer-motion';

export default function MissionVision() {
    return (
        <section id="about" className="py-12">
            <div className="relative flex flex-col md:flex-row items-center justify-center md:space-x-20 max-w-6xl mx-auto px-4">
                {/* Mission Card */}
                <motion.div
                    className="bg-[#3390FF] p-8 rounded-xl w-full md:w-[550px] xl:w-[600px] xl:h-[320px] text-white text-xl"
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.5 }}
                >
                    <h2 className="text-2xl font-bold mb-4 text-center md:text-left xl:text-center">Mission</h2>
                    <p className="leading-relaxed text-center md:text-center">
                        By harnessing the power of cloud computing, KrishiYan offers farmers and
                        FPOs a secure, scalable solution for digital farming. Its cloud-based
                        capabilities enable real-time data access, efficient management, and
                        market connectivity, all while supporting a sustainable and profitable
                        farming ecosystem.
                    </p>
                </motion.div>

                {/* Vision Card */}
                <motion.div
                    className="bg-[#3390FF] p-8 rounded-xl w-full md:w-[550px] text-white text-xl mt-12 md:mt-0 xl:w-[600px] xl:h-[320px] "
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.5, delay: 0.2 }}
                >
                    <h2 className="text-2xl font-bold mb-4 text-center md:text-center pt-10 xl:p-0  ">Vision</h2>
                    <p className="leading-relaxed text-center md:text-center">
                        Our vision is to create a sustainable and inclusive agricultural ecosystem
                        where every farmer has the opportunity to thrive, every buyer has access
                        to quality produce, and every stakeholder benefits from transparent and
                        efficient supply chains.
                    </p>
                </motion.div>

                {/* Center Logo Overlay */}
                <div
                    className="
    absolute inset-y-0 left-[49%] 
    transform -translate-x-[50%]        /* shift left by 1rem on mobile */
    -translate-y-[-2.5%]
    md:-translate-x-full            /* center its own width on md+ */
    xl:-translate-x-full           /* move a full width on xl+ */
    flex items-center 
    pointer-events-none
  "
                >
                    <img
                        src="/Images/logo1-bg.jpg"
                        alt="KrishiYan logo"
                        className="h-36 w-36 rounded-full bg-white border-4 border-white shadow-lg"
                    />
                </div>
            </div>
        </section>
    );
}
